import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

class ConfirmModal extends Component {
  render() {
    const { onConfirm, onCancel, isOpen, message } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={onCancel}>
        <ModalHeader toggle={onCancel}>UWAGA!</ModalHeader>
        <ModalBody>{message}</ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={onConfirm}>
            USUŃ
          </Button>{" "}
          <Button color="primary" onClick={onCancel}>
            Cofnij
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/components/ConfirmModal.js